import { render, staticRenderFns } from "./case.vue?vue&type=template&id=08cdbe96&scoped=true"
import script from "./case.vue?vue&type=script&lang=js"
export * from "./case.vue?vue&type=script&lang=js"
import style0 from "./case.vue?vue&type=style&index=0&id=08cdbe96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cdbe96",
  null
  
)

export default component.exports